export const getHeader = ({ deductions, contributionType }) => {
  const headers = [
    { rowSpan: 2, label: "PAYROLL PERIOD" },
    { rowSpan: 2, label: "PAYROLL TYPE" },
    { rowSpan: 2, label: "AP RATE" },
    { rowSpan: 2, label: "AP RATE FOR BACK-PAY" },
    { colSpan: 5, label: "CURRENT ASSIGNMENT" },
    { colSpan: 5, label: "AIRPORT AUGMENTATION" },
    { rowSpan: 2, label: "EXCESS AIRPORT DUTIES" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { colSpan: 2, label: "DEDUCTION BEFORE TAX" },
    { rowSpan: 2, label: "NET EARNED" },
    ...(deductions.length > 0
      ? [
          {
            colSpan: deductions.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET AMOUNT" },
  ];

  const primarySubHeaders = [
    "TOTAL DAYS DUTY",
    "PRORATED AP RATE",
    "ABSENCES/LEAVES",
    "LATES/UT PER MINUTE",
    "EARNED CURRENT ASSIGNMENT",
    "AIRPORT AUGMENTATION RATE",
    "AMOUNT EARNED AIRPORT AUGMENTATION",
    "ABSENCES/LEAVES",
    "LATES/UT PER MINUTE",
    "EARNED AIRPORT DUTIES",
    "OVERPAYMENT",
    "FLAG RAISING",
    ...deductions,
  ];
  const secondarySubHeaders = [];

  return [headers, primarySubHeaders, secondarySubHeaders];
};
